var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Outline/menu"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.26449 8H26.7352C27.4312 8 28.0005 8.56933 28.0005 9.26533V9.40133C28.0005 10.0973 27.4312 10.6667 26.7352 10.6667H5.26449C4.56849 10.6667 4.00049 10.0973 4.00049 9.40133V9.26533C4.00049 8.56933 4.56849 8 5.26449 8ZM26.7352 14.6667H5.26449C4.56849 14.6667 4.00049 15.236 4.00049 15.932V16.068C4.00049 16.764 4.56849 17.3333 5.26449 17.3333H26.7352C27.4312 17.3333 28.0005 16.764 28.0005 16.068V15.932C28.0005 15.236 27.4312 14.6667 26.7352 14.6667ZM26.7352 21.3333H5.26449C4.56849 21.3333 4.00049 21.9027 4.00049 22.5987V22.7347C4.00049 23.4307 4.56849 24 5.26449 24H26.7352C27.4312 24 28.0005 23.4307 28.0005 22.7347V22.5987C28.0005 21.9027 27.4312 21.3333 26.7352 21.3333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 8,
    width: 25,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.26449 8H26.7352C27.4312 8 28.0005 8.56933 28.0005 9.26533V9.40133C28.0005 10.0973 27.4312 10.6667 26.7352 10.6667H5.26449C4.56849 10.6667 4.00049 10.0973 4.00049 9.40133V9.26533C4.00049 8.56933 4.56849 8 5.26449 8ZM26.7352 14.6667H5.26449C4.56849 14.6667 4.00049 15.236 4.00049 15.932V16.068C4.00049 16.764 4.56849 17.3333 5.26449 17.3333H26.7352C27.4312 17.3333 28.0005 16.764 28.0005 16.068V15.932C28.0005 15.236 27.4312 14.6667 26.7352 14.6667ZM26.7352 21.3333H5.26449C4.56849 21.3333 4.00049 21.9027 4.00049 22.5987V22.7347C4.00049 23.4307 4.56849 24 5.26449 24H26.7352C27.4312 24 28.0005 23.4307 28.0005 22.7347V22.5987C28.0005 21.9027 27.4312 21.3333 26.7352 21.3333Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\x8E\xA8 Color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 32,
    height: 32,
    fill: "black"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.197dbe50.svg";
export { ForwardRef as ReactComponent };